'use client'

import Heading from '@/components/Heading/Heading'
import ContextualHelpModal from '@/components/Help/ContextualHelpModal'
import ThemeListView from './ThemeListView'
import Machine from './Machine'
import { useCallback, useState } from 'react'

const tabs = [
  {
    name: 'Themes',
  },
  {
    name: 'Customizer Config',
  },
]

export default function Home() {
  const [selectedTab, setSelectedTab] = useState(0)
  const [isHelpOpen, setIsHelpOpen] = useState(false)

  const handleOnSelectedTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const getCurrentTabContent = useCallback(() => {
    switch (selectedTab) {
      case 0:
        return <ThemeListView />
      case 1:
        return <Machine />
      default:
        return <ThemeListView />
    }
  }, [selectedTab])

  return (
    <div className="flex w-full bg-white gap-[32px]">
      <div className="flex-grow">
        <Heading
          title={'Settings'}
          description={'Manage themes and company settings.'}
          help={{
            title: 'Help',
            onClick: () => setIsHelpOpen(true),
          }}
          tab={{
            onSelectedChange: handleOnSelectedTabChange,
            selectedTab: selectedTab,
            tabs: tabs,
          }}
        />
        <div className={'pr-xxl block'}>{getCurrentTabContent()}</div>
      </div>
      <ContextualHelpModal categoryId="settings" isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </div>
  )
}
